import type { PagesProps } from '@graphcommerce/framer-next-pages'
import type { IfConfig, PluginProps } from '@graphcommerce/next-config'
import { FacebookPixelScript } from '../components/FacebookPixel/FacebookPixelScript'

export const component = 'FramerNextPages'
export const exported = '@graphcommerce/framer-next-pages'
export const ifConfig: IfConfig = 'fbPixelId'

function FbPixelFramerNextPages(props: PluginProps<PagesProps>) {
  const { Prev, ...rest } = props
  return (
    <>
      <FacebookPixelScript />
      <Prev {...rest} />
    </>
  )
}

export const Plugin = FbPixelFramerNextPages
